export enum JobStatusNewType {
  OPEN,
  ACTIVE,
  CLOSED,
  CANCELLED
}

export const JobStatusNewLabelType = {
  [JobStatusNewType.OPEN]: 'Open',
  [JobStatusNewType.ACTIVE]: 'Active',
  [JobStatusNewType.CLOSED]: 'Closed',
  [JobStatusNewType.CANCELLED]: 'Cancelled'
}

export enum JobStatusFilterLabels {
  OPEN = 'Open',
  ACTIVE = 'Active',
  CLOSED = 'Closed',
  CANCELLED = 'Cancelled'
}
